import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  ElementRef,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { MainAppComponent } from "../../../layout/layout.component";
import { CharacteristicModel } from "../../../common/viewModels/GlobalRegistry/CharacteristicsModel";
import { UnitsModel } from "../../../common/viewModels/GlobalRegistry/UnitsModel";
import { SampleModel } from "../../../common/viewModels/Analysis/SampleModel";
import { AnalysisElementSectionTypeModel } from "../../../common/viewModels/Analysis/SampleModel";
import { TestMethodModel } from "../../../common/viewModels/Analysis/SampleModel";
import { TestRatingModel } from "../../../common/viewModels/Analysis/SampleModel";
import "rxjs/add/operator/map";
import {
  SampleTypesEnum,
  TransformerOilRating,
} from "../../../common/enumcontainer.enum";

@Component({
  selector: "addsampleresults",
  templateUrl: "./addsampleresults.component.html",
  styleUrls: ["./addsampleresults.component.css"],
})
export class AddSampleResults implements OnInit {
  @ViewChildren("results") enteredResults: QueryList<ElementRef>;

  addeditresults: FormGroup;
  lstAnalysisSections: AnalysisElementSectionTypeModel[];
  lstGroupSections: any[];
  sample: SampleModel = new SampleModel();
  characteristics: CharacteristicModel[];
  testMethods: TestMethodModel[];
  testRatings: TestRatingModel[];
  units: UnitsModel[];
  id: number;
  isFormValid: boolean = true;
  ratingId: any[];
  showCharsWarnMsg: boolean = false;
  sampleTypesEnum: any;
  sampleTypeId: number;
  viTable: { kv100: number; U: number; L: number }[] = [];

  readonly CHAR_Viscosity40 = 130;
  readonly CHAR_Viscosity100 = 127;
  readonly CHAR_VI = 133;//Viscosity INDEX
  readonly allowedSampleTypes = [1, 3, 4];

  constructor(
    public _router: Router,
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService
  ) { }

  ngOnInit() {
    this.sampleTypesEnum = SampleTypesEnum;
    this.id = this._route.snapshot.params["id"];
    this.GetListOfSectionChars(this.id);
    this.GetUnitsList();
    this.GetTestMethodsList();
    //this.GetTestRatingsList();
    this.addeditresults = this._formBuilder.group({});
  }

  GetUnitsList() {
    this._http.get(this._appUrl.GetUnitsForDDL).subscribe(
      (data) => {
        this.units = data.json().Result;
      },
      (error) => {
        this._toastrService.error("Error occured", "");
      }
    );
  }

  MakeGradeMand(id) {
    if (this.ratingId.filter((m) => m != id)) this.ratingId.push(id);
  }

  ShowErrorMsg(id) {
    for (let item of this.ratingId) {
      if (id == item) {
        return true;
      }
    }
    return false;
  }

  GetTestRatingsList() {
    this._http.get(this._appUrl.GetListOfTestRatings).subscribe(
      (data) => {
        if (data.json().Result != null) {
          const rawData = data.json().Result;
          const excludedRatingIds = [
            TransformerOilRating.Good,
            TransformerOilRating.Fair,
            TransformerOilRating.Poor,
          ];
          if (this.sampleTypeId != undefined) {
            if (this.sampleTypeId == SampleTypesEnum.TransformerOil) {
              this.testRatings = rawData.filter((item) =>
                excludedRatingIds.includes(item.TestRatingId)
              );
            } else {
              this.testRatings = rawData.filter(
                (item) => !excludedRatingIds.includes(item.TestRatingId)
              );
            }
          } else {
            this.testRatings = rawData.filter(
              (item) => !excludedRatingIds.includes(item.TestRatingId)
            );
          }
        }
      },
      (error) => {
        this._toastrService.error("Error occurred", "");
      }
    );
  }

  GetTestMethodsList() {
    this._http.get(this._appUrl.GetListOfMinTestMethods).subscribe(
      (data) => {
        if (data.json().Result != null) this.testMethods = data.json().Result;
      },
      (error) => {
        this._toastrService.error("Error occured", "");
      }
    );
  }

  GetListOfSectionChars(id) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetListOfSectionChars + id).subscribe(
      (data) => {
        this._mApp.HideLoader();
        if (data.json().Result != null) {
          this.sample = data.json().Result;
          this.lstAnalysisSections = this.sample.LstAnalysis;
          this.lstGroupSections = this.sample.lstGroupSections;
          this.showCharsWarnMsg =
            this.sample.LstAnalysis.length > 0 ? false : true;
          this.sampleTypeId = this.sample.SampleTypeId;
          this.GetTestRatingsList();
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error("Error occured", "");
      }
    );
  }

  CheckValidity(lst: any) {
    for (let i = 0; i < lst.length; i++) {
      if (lst[i].TestRatingId == undefined) lst[i].TestRatingId = 0;
      if (
        lst[i].Result != null &&
        lst[i].Result.length > 0 &&
        parseInt(lst[i].TestRatingId) == 0
      ) {
        this.isFormValid = false;
        return;
      } else {
        this.isFormValid = true;
      }
    }
  }

  OnSubmit(IsSaveNext) {
    if (this.isFormValid) {
      this._mApp.ShowLoader();
      if (this.sample != null)
        this.sample.LstAnalysis = this.lstAnalysisSections;
      var values = this.sample;
      this._http.post(this._appUrl.UpsertSampleResultChars, values).subscribe(
        (data) => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, "");
          if (IsSaveNext)
            this._router.navigate(["/approvesampleresults", this.id]);
          else this._router.navigate(["/samplestatus"]);
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        }
      );
    }
  }

  GetAutoTestRatingForLubChar(index, event) {
    //checking if the pressed key is tab
    if (event.keyCode == 9) {
      this._mApp.ShowLoader();
      let sample = new SampleModel();
      sample.SampleId = this.sample.SampleId;
      sample.SampleTypeId = this.sample.SampleTypeId;
      sample.CharacteristicId =
        this.lstAnalysisSections[index].CharacteristicId;
      sample.Result = this.lstAnalysisSections[index].Result;
      this._http
        .post(this._appUrl.GetAutoTestRatingForLubChar, sample)
        .subscribe(
          (data) => {
            this._mApp.HideLoader();
            let res = data.json().Result;
            if (res != null && res != "" && res != undefined) {
              this.lstAnalysisSections[index].TestRatingId = res;
            }
            if (this.enteredResults.length > index + 1)
              this.enteredResults.toArray()[index + 1].nativeElement.focus();
          },
          (error) => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result, "");
          }
        );
    }
  }

  /* ===============================
     🔥 CALL BACKEND API
  ===============================*/
  calculateVIFromApi(kv40: number, kv100: number, viIndex: number) {

  const payload = {
    Kv40: kv40,
    Kv100: kv100
  };

  this._http.post(this._appUrl.CalculateViscosityIndex, payload)
    .map(res => res.json())
    .subscribe(
      data => {
        const vi = data.Result;
        if (vi !== null && vi !== undefined) {
          this.lstAnalysisSections[viIndex].Result = vi.toString();
        }
      },
      error => {
        // this._toastrService.error("Failed to calculate Viscosity Index");
      }
    );
}


  /* ===============================
     🔥 NEW METHOD (KEY CHANGE)
     Triggers when Transformer Oil KV40 / KV100 changes
  ===============================*/
  onResultInputChange(index: number) {
    const current = this.lstAnalysisSections[index];
    let VI40: number = null;
    let VI100: number = null;
    let viIndex = -1;

    // Read values from grid
    this.lstAnalysisSections.forEach((item, i) => {
      if (item.CharacteristicId === this.CHAR_Viscosity40) {
        VI40 = parseFloat(item.Result);
      }
      if (item.CharacteristicId === this.CHAR_Viscosity100) {
        VI100 = parseFloat(item.Result);
      }
      if (item.CharacteristicId === this.CHAR_VI) {
        viIndex = i;
      }
    });

    if (!VI40 || !VI100 || viIndex === -1) {
      return;
    }

    this.calculateVIFromApi(VI40, VI100, viIndex);
  }

  onResultValueChange(i: number, item: any): void {
    
  if (!item || !item.Result) {
    return;
  }

  const isAllowedSample =
    this.allowedSampleTypes.includes(item.SampleTypeId);

  const isViscosityChar =
    item.CharacteristicId === this.CHAR_Viscosity40 ||
    item.CharacteristicId === this.CHAR_Viscosity100;

  if (isAllowedSample && isViscosityChar) {
    this.onResultInputChange(i); 
  }
}

}
